import { Fragment } from 'react';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { BgShadow } from '../BgShadow';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && <BgPlaceholder $type={PlaceholderType.Default} />}
		<BgShadow className={`${Layouts.GasStation}-background`} />
	</Fragment>
);

export { Background };
